const convertDateString = (
  dateString: string,
  formatString: string
): string => {
  const date = new Date(dateString);

  const formatMap: { [key: string]: () => string } = {
    yyyy: () => date.getFullYear().toString(),
    mm: () => (date.getMonth() + 1).toString().padStart(2, '0'),
    dd: () => date.getDate().toString().padStart(2, '0'),
    hh: () => date.getHours().toString().padStart(2, '0'),
    mi: () => date.getMinutes().toString().padStart(2, '0'),
  };

  const isValidFormatString = (format: string): boolean => {
    const validSpecifiers = Object.keys(formatMap);
    const parts = format.split(/[^a-zA-Z]+/);
    return parts.every(
      (part) => !part || validSpecifiers.includes(part.toLowerCase())
    );
  };

  if (!isValidFormatString(formatString)) {
    throw new Error('Invalid format string');
  }

  return formatString.replace(/yyyy|mm|dd|hh|mi/gi, (match) => {
    const formatter = formatMap[match.toLowerCase()];
    return formatter ? formatter() : match;
  });
};

export default convertDateString;
